import {
  SET_USER_LOGIN_DATA,
  SHOW_ONBOARD,
  REMOVE_USER_LOGIN_DATA,
  SET_USER_DATA,
  SET_USER_ADDRESSES,
  ADD_USER_ADDRESS,
  UPDATE_USER_ADDRESS,
  REMOVE_USER_ADDRESS,
} from "./types";

export const setOnboardSeen = () => ({
  type: SHOW_ONBOARD,
});

export const setUserLoginData = (data) => ({
  type: SET_USER_LOGIN_DATA,
  data: data,
});

export const logoutUser = () => ({
  type: REMOVE_USER_LOGIN_DATA,
});

export const setUserData = (data) => ({
  type: SET_USER_DATA,
  data: data,
});

export const setAddresses = (data) => ({
  type: SET_USER_ADDRESSES,
  data: data,
});

export const addAddress = (data) => ({
  type: ADD_USER_ADDRESS,
  data: data,
});

export const updateAddress = (data) => ({
  type: UPDATE_USER_ADDRESS,
  data: data,
});

export const removeAddress = (data) => ({
  type: REMOVE_USER_ADDRESS,
  data: data,
});
